// Helpers barrel export

export {
  isAndroidDevice,
  isIOSDevice,
  isMobileWeb,
  getPlatformType,
  checkIfAppInstalled,
  clearAppInstallCache,
  isBannerDismissed,
  dismissBanner,
} from './appDetection';

export {
  loadAppsFlyerSmartScript,
  isSmartScriptReady,
  generateOneLinkURL,
  generateFallbackOneLinkURL,
  initAndGenerateOneLinkURL,
} from './appsFlyerSmartScript';

export {
  getAppMigrationOneLinkUrl,
} from './appsFlyerLinks';
export type {
  AppMigrationOneLinkTouchpoint,
  IAppMigrationAppsFlyerLink,
  IAppMigrationAppsFlyerLinks,
} from './appsFlyerLinks';

export {
  shouldShowAppMigrationTopBanner,
} from './topBannerVisibility';
export type { IShouldShowTopBannerParams } from './topBannerVisibility';

/**
 * Derive page type from the current URL pathname
 * Used by app migration banners to pass correct page_type to AppsFlyer
 */
export const getPageType = (pathname: string): string => {
  if (pathname === '/') return 'home';
  if (/\/p\//.test(pathname)) return 'pdp';
  if (/\/catalogsearch\/result/.test(pathname)) return 'plp';
  if (/\/c\//.test(pathname)) return 'plp';
  if (/\/lp\//.test(pathname)) return 'landing';
  if (/\/wishlist/.test(pathname)) return 'wishlist';
  if (/\/v2\/checkout/.test(pathname)) return 'checkout';

  return 'other';
};


export const navigateToURL = (url: string): void => {
  if (typeof window === 'undefined' || !url) return;

  window.open(url, '_self');
};
